// Unidades federativas do Brasil (siglas) — fonte única reusada nos formulários
// (form de cliente, dados do advogado no Secretário, etc.).
export const UFS = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG',
  'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
];

// Opções prontas para o <Combobox> (value === label === sigla).
export const UF_OPTIONS = UFS.map((uf) => ({ value: uf, label: uf }));

// O nome com a preposição ("de Alagoas", "da Bahia", "do Rio de Janeiro"), para frases
// como "Todo o estado de Alagoas". O DF não é estado: quem usa trata à parte.
export const UF_COM_PREPOSICAO: Record<string, string> = {
  AC: 'do Acre', AL: 'de Alagoas', AP: 'do Amapá', AM: 'do Amazonas', BA: 'da Bahia', CE: 'do Ceará',
  DF: 'do Distrito Federal', ES: 'do Espírito Santo', GO: 'de Goiás', MA: 'do Maranhão', MT: 'de Mato Grosso',
  MS: 'de Mato Grosso do Sul', MG: 'de Minas Gerais', PA: 'do Pará', PB: 'da Paraíba', PR: 'do Paraná',
  PE: 'de Pernambuco', PI: 'do Piauí', RJ: 'do Rio de Janeiro', RN: 'do Rio Grande do Norte',
  RS: 'do Rio Grande do Sul', RO: 'de Rondônia', RR: 'de Roraima', SC: 'de Santa Catarina', SP: 'de São Paulo',
  SE: 'de Sergipe', TO: 'do Tocantins',
};
